import { render, staticRenderFns } from "./ListCompare2.vue?vue&type=template&id=4400b79f"
import script from "./ListCompare2.vue?vue&type=script&lang=js"
export * from "./ListCompare2.vue?vue&type=script&lang=js"
import style0 from "./ListCompare2.vue?vue&type=style&index=0&id=4400b79f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports